import { useEffect, useState } from 'react';
import CardProduct from '../../card/CardProduct/CardProduct';
import LeftMenuDesign from '../../common/LeftMenuDesign/LeftMenuDesign';
import './LeftInsideCustomDesignMenu.scss';
import { useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import DropdownFilter from '../../common/DropdownFilter/DropdownFilter';
import { Icon } from '../../icon/icon';
import ButtonIconOutlineMedium from '../../common/ButtonIconOutline/ButtonIconOutlineMedium';
import SearchComponent from '../../common/SearchComponent/SearchComponent';
import ButtonIconGhostMedium from '../../common/ButtonIconGhost/ButtonIconGhostMedium';
import callApi from '../../../utils/api/callAPI';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { useTranslation } from 'react-i18next';

const LeftInsideCustomDesignMenu = ({ open, onDragStart, title }) => {
  const { t } = useTranslation();
  const [insides, setInsides] = useState([]);
  // const [loading, setLoading] = useState(false);

  const [currentProduct, setCurrentProduct] = useState();
  const [openSearch, setOpenSearch] = useState(false);
  const [listTypeProduct, setListTypeProduct] = useState([]);
  const { products } = useSelector(state => state.product);
  const [searchParams, setSearchParams] = useSearchParams();
  const subType = searchParams.get('sub_type');
  const { type } = useParams();

  useEffect(() => {
    const product = products.data?.find(item => item.type_design === subType);
    if (product) {
      const listTypeProduct = product.types
        ?.filter(item => item.code !== null)
        .map(item => ({
          key: item.id,
          label: item.name,
        }));
      if (listTypeProduct.length) {
        setListTypeProduct([...listTypeProduct]);
        setCurrentProduct(listTypeProduct[0].key);
      }
    }
  }, [subType, products]);

  // Fetch data trực tiếp bằng API call
  useEffect(() => {
    if (!currentProduct) return;

    const fetchData = async () => {
      try {
        // setLoading(true);
        // const response = await callApi({
        //   endpoint: `modules/v3/inside-accessories?product_type=${currentProduct}`,
        //   method: 'get',
        // });

        const response = await callApi({
          endpoint: `modules/v3/inside-accessories`,
          method: 'get',
          params: {
            product_type: currentProduct,
            country_code: process.env.REACT_APP_COUNTRY_CODE,
          },
        });
        // Lấy chỉ phần insides
        setInsides(response?.data?.result?.data?.insides ?? []);
      } catch (error) {
        console.error('Error fetching insides:', error);
        setInsides([]);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, [currentProduct]);

  return (
    <LeftMenuDesign
      open={open}
      classNames={{
        root: '!left-[60px] relative',
        content: '!p-0 gap-0',
      }}
      header={<span className="text-title-large text-nowrap">{title}</span>}
      content={
        <>
          {/* <div className="flex py-8 px-16 bg-fills-white">
            <ListTypeModule />
          </div>
          <Divider type="horizontal" style={{ margin: 0 }} /> */}
          <div className="left-cabinet-design-menu-header-actions bg-fills-white">
            <div className="flex self-stretch">
              <CSSTransition
                in={!openSearch}
                classNames={'container-dropdown'}
                appear
                timeout={300}
              >
                <div className={'flex items-start gap-8 self-stretch'}>
                  <DropdownFilter
                    trigger={['click']}
                    menu={{
                      items: [
                        ...listTypeProduct.map(item => ({
                          ...item,
                          label: (
                            <div
                              className="flex px-12 py-8 justify-between items-center"
                              onClick={() => setCurrentProduct(item.key)}
                            >
                              <span className="text-body-medium">
                                {getValueFromString(item.label)}
                              </span>
                              {currentProduct === item.key && (
                                <span className="w-20 h-20 flex">
                                  <Icon.ICCheck />
                                </span>
                              )}
                            </div>
                          ),
                        })),
                      ],
                    }}
                    size="default"
                    className={'flex-row-reverse grow'}
                    value={getValueFromString(
                      listTypeProduct.find(item => item.key == currentProduct)
                        ?.label ?? t('Please select')
                    )}
                  />
                  <ButtonIconOutlineMedium
                    icon={<Icon.ICSearch />}
                    onClick={() => {
                      // setOpenSearch((prev) => !prev);
                    }}
                  />
                </div>
              </CSSTransition>
              {/* <CSSTransition
                in={openSearch}
                classNames={'container-search'}
                appear
                timeout={300}
              >
                <div
                  className={
                    'flex flex-col justify-start items-start bg-fills-white rounded-[8px] outline container-search'
                  }
                >
                  <div className="flex items-center gap-2">
                    <SearchComponent
                      value={''}
                      setValue={function () {}}
                      size="small"
                      styles={{ input: { width: '100%' } }}
                    />
                    <ButtonIconGhostMedium
                      icon={<Icon.ICClose />}
                      onClick={() => setOpenSearch(false)}
                    />
                  </div>
                  <div className="flex flex-col items-start gap-2 mt-16">
                    <div
                      className="flex p-8 items-center gap-8 self-stretch text-body-small"
                      style={{ color: '#5A5D60' }}
                    >
                      Tủ đơn
                    </div>
                  </div>
                </div>
              </CSSTransition> */}
            </div>
            {/* <ListTypeModule /> */}
            {/* </div> */}
          </div>
          <div className="grid p-8 items-start align-content-start gap-2 self-stretch grid-cols-2">
            {insides?.map((md, i) => {
              const name = getValueFromString(md.name);
              const description = getValueFromString(md.description ?? '');

              return (
                <CardProduct
                  key={i}
                  md={md}
                  title={name}
                  description1={description}
                  description2={md.size}
                  moduleType={i}
                  onDragStart={onDragStart}
                />
              );
            })}
          </div>
        </>
      }
    />
  );
};

export default LeftInsideCustomDesignMenu;
